var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSplitYellow24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4H10L7.71 6.29L13 11.59V20H11V12.41L6.29 7.71L4 10V4ZM16.29 6.29L14 4H20V10L17.71 7.71L14.83 10.59L13.41 9.17L16.29 6.29Z",
    fill: "#FBC70E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSplitYellow24Px);
export default __webpack_public_path__ + "static/media/ic_split_yellow_24px.abc089828477ade8a13f1a23d555fba5.svg";
export { ForwardRef as ReactComponent };